import { render } from "./PageViewListPage.vue?vue&type=template&id=87a1b882&scoped=true"
import script from "./PageViewListPage.vue?vue&type=script&lang=js"
export * from "./PageViewListPage.vue?vue&type=script&lang=js"

import "./PageViewListPage.vue?vue&type=style&index=0&id=87a1b882&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-87a1b882"

export default script